<template>
  <div class="home-container">
    <!-- 主体内容区域（主内容 + 右侧资讯） -->
    <div class="main-and-news-side">
      <div class="main-content">
        <div class="content-center">
          <template v-if="currentTabKey === 'home'">
            <AppContent />
          </template>
        </div>
      </div>
      <!-- 右侧资讯区域 -->
      <NewsSide />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import AppContent from '@/components/appContent.vue';
import NewsSide from '@/components/newsSide.vue'; 
//import ChatComponent from '@/components/chatComponent.vue';
export default {
  components: {
    AppContent,
    NewsSide,
   // ChatComponent 
  },
  setup() {
    const isChatVisible = ref(false);
    const currentTabKey = ref('home');
    const toggleChat = () => {
      isChatVisible.value = !isChatVisible.value;
    };
    return {
      isChatVisible,
      toggleChat,
      currentTabKey
    };
  }
};
</script>

<style scoped>
/* 整体容器，设置为可滚动，成为唯一的滚动容器，包含左侧菜单和主内容 */
.home-container {
  display: flex;
  height: calc(100vh - 100px);
  overflow: hidden;
}

/* 主内容 + 右侧资讯 容器 */
.main-and-news-side {
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* 主内容区域（包含2模块） */
.main-content {
  flex: 3;
  padding: 20px;
  background-color: #f9fafb;
  transition: padding-right 0.3s ease;
  width: 100%;
  height: 100%;
  overflow-y: auto; /* 中间区域可滚动 */
}

/* 右侧资讯区域 */
.news-side {
  flex: 1;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  height: 100%;
  overflow-y: auto; /* 右侧资讯也可滚动 */
}

/* 内容居中容器 */
.content-center {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 新增全局卡片样式类 */
.card-shadow {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s;
}
.card-shadow:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
@media (max-width: 1200px) {
  .main-and-news-side {
    flex-direction: column;
  }
  .news-side {
    width: 100%;
    margin-top: 20px;
  }
}

</style>
